import { FilterToolbarGroup } from 'src/components/Filters';
import { ContentId } from 'src/utils/constants/contentId';
import { ActionOutboxEntityType } from 'src/WebApiController';

import { useTagFiltersBase } from './useTagFiltersBase';

export type EventTagInfoFilter = {
  eventTagName: string | null;
  eventTagValue: string | null;
};

export const useEventTagFilters = <TFilter extends EventTagInfoFilter>(
  query: TFilter,
  setQuery: (query: TFilter) => void,
  disabled?: boolean
): FilterToolbarGroup => {
  return useTagFiltersBase(
    query.eventTagName,
    query.eventTagValue,
    (eventTagName) => setQuery({ ...query, eventTagName }),
    (eventTagValue) => setQuery({ ...query, eventTagValue }),
    ContentId.EventTag,
    ActionOutboxEntityType.SellerEvent,
    undefined,
    disabled,
    'eventTagKey',
    'eventTagValue'
  );
};
